<mat-sidenav-container class="search-container" id="search-sidenav-container">
  <mat-sidenav
    #sidenav
    id="search-sidenav"
    [(opened)]="isSidenavOpen"
    class="search-container__sidenav"
    [mode]="sidenavMode"
    [attr.color]="'primary'"
  >
    <ng-content select="[searchNavbar]"></ng-content>
  </mat-sidenav>

  <mat-sidenav-content
    class="search-container__content"
    [class.site-selected]="siteSelected$ | async"
  >
    <app-ad-banner
      *ngIf="hasBanner"
      [ngClass]="isSidenavOpen ? 'small' : ''"
    ></app-ad-banner>
    <div class="search-container__content-main" [class.on-card]="contentOnCard">
      <app-breadcrumb [contentOnCard]="contentOnCard"></app-breadcrumb>
      <button
        *ngIf="showPanel"
        class="search-container__close-btn"
        id="search-container-close-btn"
        mat-flat-button
        color="primary"
        (click)="sidenav.toggle()"
      >
        <mat-icon>tune</mat-icon
        ><span class="search-container__close-btn-filter">{{
          "SEARCH.FILTERS" | translate
        }}</span>
      </button>

      <ng-container *ngIf="contentOnCard; else content">
        <app-main-content-card [wideContent]="true">
          <ng-container *ngTemplateOutlet="content"></ng-container>
        </app-main-content-card>
      </ng-container>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>

<ng-template #content>
  <ng-content select="[searchContent]"></ng-content>
</ng-template>
